module.exports = __webpack_public_path__ + "img/Loading_r_31.67ad5ade.png";